<fdr-past-performance-ui-base-card [title]="'PD.PERFORMANCE.OVERVIEW' | translate" [subtitle]="dateRange">
  <dsy-button
    header-right
    class="chart-header__download"
    [iconSide]="'left'"
    [iconName]="'download'"
    [iconLibrary]="'material'"
    [iconSize]="'1.16rem'"
    variant="link"
    color="neutral"
    (click)="downloadChart()"
    [disabled]="isLoading() || !hasData()"
  >
    {{ 'PD.BUTTONS.DOWNLOAD' | translate }}
  </dsy-button>

  @if (isLoading()) {
    <div class="chart-state chart-state--loading">
      <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
    </div>
  } @else if (!hasData()) {
    <div class="chart-state">
      <fdr-past-performance-ui-empty-state
        icon="search_off"
        title="PD.LABELS.NO_DATA_DISPATCH_AVAILABLE"
        subtitle="PD.LABELS.SELECTED_FILTERS"
        [emphasized]="true"
      ></fdr-past-performance-ui-empty-state>
    </div>
  } @else {
    <fdr-past-performance-ui-chips [chipsData]="chipsInfo()" (onPress)="disableChip($event)"></fdr-past-performance-ui-chips>
	
  }

  <canvas #chartCanvas [style.display]="isLoading() || !hasData() ? 'none' : 'block'"></canvas>
</fdr-past-performance-ui-base-card>
